import { Button, Typography } from '@mui/material';

import { ALLOW_SLIDER_ITEMS_PREFETCH } from '@/constants/prefetch';
import { FC } from 'react';
import Link from 'next/link';
import { OfferBanner } from '@/logic/services';
import { pxToRem } from '@/theme/typography';
import { useCity } from '@/logic/hooks';
import { ValidationTypes } from '@/constants/offers';

interface SliderOfferInfoProps {
  primaryColor: string;
  secondaryColor: string;
  offerBanner: OfferBanner;
}

export const SliderOfferInfo: FC<SliderOfferInfoProps> = ({
  primaryColor,
  secondaryColor,
  offerBanner,
}) => {
  const { cityId } = useCity();

  const { title, uniqueName, validationType, bankName, hint } = offerBanner.offer;

  return (
    <>
      <Typography
        sx={{
          fontWeight: 700,
          fontFamily: 'co-head-line-corp-bold',
          lineHeight: pxToRem(35.13),
          color: primaryColor,
          marginBottom: pxToRem(24),
          marginX: {
            mobile: '32px',
            laptop: '0px',
          },
          fontSize: {
            tablet: pxToRem(30),
            mobile: '22px',
          },
          textAlign: {
            mobile: 'center',
            laptop: 'start',
          },
        }}
      >
        {title}
      </Typography>

      <Typography
        component='span'
        sx={{
          display: 'block',
          color: secondaryColor,
          fontSize: pxToRem(24),
          letterSpacing: pxToRem(0.1),
        }}
      >
        {validationType === ValidationTypes.BIN ? bankName : hint}
      </Typography>

      <Link
        href={{
          pathname: `/offers/${uniqueName}`,
          // Omit cityId entirely when there is none, rather than emitting
          // `?cityId=` — see the same fix in slider-film-info.tsx.
          query: {
            ...(cityId && { cityId }),
          },
        }}
        legacyBehavior
        passHref
        prefetch={ALLOW_SLIDER_ITEMS_PREFETCH}
      >
        <Button
          id={`slider-${offerBanner.id}-btn`}
          variant='contained'
          component='a'
          aria-label={`${offerBanner.buttonText} – ${title}`}
          sx={{
            marginTop: pxToRem(16),
            paddingX: pxToRem(49),
            paddingY: pxToRem(18),
            fontFamily: 'co-head-line-corp-bold',
            borderRadius: pxToRem(16),
            height: { tablet: pxToRem(56), mobile: '56px' },
            fontSize: {
              mobile: '16px',
              tablet: pxToRem(16),
            },
            fontWeight: '700',
          }}
        >
          {offerBanner.buttonText}
        </Button>
      </Link>
    </>
  );
};
